import { TOGGLE_SPINNER_STATE, TOGGLE_TRANSACTIONS_SPINNER_STATE } from "../actions/constants";

export const spinnerReducer = (state = false, { type, payload }) => {
    switch (type) {
        case TOGGLE_SPINNER_STATE:
            return payload;
        default:
            return state;
    }
};

export const transactionsLoadingReducer = (state = false, { type, payload }) => {
    switch (type) {
        case TOGGLE_TRANSACTIONS_SPINNER_STATE:
            return payload;
        default:
            return state;
    }
};
